export default class ArchiveParams {
  constructor(markAsToDelete = false) {
      this.markAsToDelete = markAsToDelete;
  }
}
